import { CoachingCaseDetail } from '@euler/model/coaching';
import { useServiceFactory } from '@euler/services/factory';
import { useCallback, useEffect, useState } from 'react';

export type CaseDetailState =
  | { kind: 'loading' }
  | { kind: 'failed' }
  | { kind: 'ready'; detail: CoachingCaseDetail };

export function useCaseDetail(caseId: string): {
  state: CaseDetailState;
  reload: () => void;
} {
  const { coachingService } = useServiceFactory();
  const [state, setState] = useState<CaseDetailState>({ kind: 'loading' });
  const [reloadKey, setReloadKey] = useState(0);
  const reload = useCallback(() => setReloadKey(k => k + 1), []);
  useEffect(() => {
    let active = true;
    setState({ kind: 'loading' });
    coachingService
      .getCase(caseId)
      .then(detail => {
        if (active) setState({ kind: 'ready', detail });
      })
      .catch(error => {
        console.error('coaching case failed', error);
        if (active) setState({ kind: 'failed' });
      });
    return () => {
      active = false;
    };
  }, [coachingService, caseId, reloadKey]);
  return { state, reload };
}
